<div class="fieldset-area mb-3">
  <fieldset [style]="deep">
    <legend *ngIf="legend">{{ legend }}</legend>
    <ng-content></ng-content>
  </fieldset>
</div>
